(() => {
  const endpoint = "https://tall-jobs-admire.loca.lt/api/cart-event";
  const visitorKey = 'tbk_cart_monitor_visitor';
  const sessionKey = 'tbk_cart_monitor_session';
  const now = Date.now();
  const getId = (key, prefix, sessionOnly) => {
    try {
      const store = sessionOnly ? window.sessionStorage : window.localStorage;
      let id = store.getItem(key);
      if (!id) {
        id = prefix + '-' + now.toString(36) + '-' + Math.random().toString(36).slice(2, 10);
        store.setItem(key, id);
      }
      return id;
    } catch {
      return prefix + '-' + now.toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    }
  };
  const visitorId = getId(visitorKey, 'visitor', false);
  const sessionId = getId(sessionKey, 'session', true);
  let lastSignature = '';
  let pending = null;

  async function getCart() {
    const response = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('cart_fetch_failed');
    return response.json();
  }

  function signature(type, cart) {
    const items = (cart.items || []).map((item) => [item.key, item.quantity, item.final_line_price].join(':')).join('|');
    return [type, cart.item_count, cart.total_price, items].join('::');
  }

  function send(type, cart) {
    const sig = signature(type, cart);
    if (sig === lastSignature && type === 'cart_snapshot') return;
    lastSignature = sig;
    const payload = {
      type,
      visitorId,
      sessionId,
      page: window.location.href,
      referrer: document.referrer || null,
      cart
    };
    const body = JSON.stringify(payload);
    if (navigator.sendBeacon) {
      try {
        const sent = navigator.sendBeacon(endpoint, new Blob([body], { type: 'application/json' }));
        if (sent) return;
      } catch {}
    }
    fetch(endpoint, {
      method: 'POST',
      mode: 'cors',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body
    }).catch(() => {});
  }

  async function snapshot(type) {
    clearTimeout(pending);
    pending = setTimeout(async () => {
      try {
        const cart = await getCart();
        send(type, cart);
      } catch {}
    }, 450);
  }

  snapshot('cart_snapshot');

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
      snapshot('add_to_cart_form');
      setTimeout(() => snapshot('cart_after_add'), 1600);
    }
  }, true);

  document.addEventListener('click', (event) => {
    const target = event.target && event.target.closest ? event.target.closest('a, button, input[type="submit"]') : null;
    if (!target) return;
    const text = (target.textContent || target.value || '').toLowerCase();
    const href = target.getAttribute && target.getAttribute('href');
    if ((href && href.includes('/checkout')) || text.includes('checkout')) snapshot('checkout_click');
    if ((href && href.includes('/cart')) || text.includes('cart')) snapshot('cart_click');
  }, true);

  if (window.location.pathname === '/cart' || window.location.pathname.startsWith('/cart/')) {
    window.setInterval(() => snapshot('cart_page_poll'), 15000);
  }
})();

/* TBK brand logo grid safety start */
(() => {
  const brands = [
    ['Akrapovic', '/collections/vendors?q=Akrapovic', 'tbk-brand-logo-akrapovic.svg', false],
    ['aFe POWER', '/search?q=aFe+POWER&type=product', 'tbk-brand-logo-afe-power.svg', false],
    ['Boost Logic', '/collections/vendors?q=Boost%20Logic', 'tbk-brand-logo-boost-logic.png', true],
    ['AMS Performance', '/collections/vendors?q=AMS%20Performance', 'tbk-brand-logo-ams-performance.svg', false],
    ['BMC', '/collections/vendors?q=BMC', 'tbk-brand-logo-bmc.png', false],
    ['Capristo', '/collections/vendors?q=Capristo', 'tbk-brand-logo-capristo.svg', false],
    ['CSF', '/collections/vendors?q=CSF', 'tbk-brand-logo-csf.svg', false],
    ['Rampage', '/collections/vendors?q=Rampage%20Fabrication', 'tbk-brand-logo-rampage-light.png', true],
    ['Heffner Performance', '/search?q=Heffner%20Performance&type=product', 'tbk-brand-logo-heffner-performance.jpg', false],
    ['H&R', '/collections/vendors?q=H%26R', 'tbk-brand-logo-hr.png', false],
    ['Vorsteiner', '/collections/vendors?q=Vorsteiner', 'tbk-brand-logo-vorsteiner.png', true],
    ['KW', '/collections/vendors?q=KW', 'tbk-brand-logo-kw.svg', false],
    ['Bilstein', '/collections/vendors?q=Bilstein', 'tbk-brand-logo-bilstein.png', false],
    ['K&N Engineering', '/collections/vendors?q=K%26N%20Engineering', 'tbk-brand-logo-kn-engineering.svg', false],
    ['MATTS', '/collections/vendors?q=MATTS', 'tbk-brand-logo-matts.svg', true],
    ['Clutch Masters', '/collections/vendors?q=Clutch%20Masters', 'tbk-brand-logo-clutch-masters.png', false],
    ['Pearson Tuned', '/collections/vendors?q=Pearson%20Tuned', 'tbk-brand-logo-pearson-tuned.png', false],
    ['Vossen', '/collections/vendors?q=Vossen', 'tbk-brand-logo-vossen.svg', false],
  ];

  const escapeHtml = value => String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

  const getAssetBase = () => {
    const script = Array.from(document.scripts).find(item => /\/assets\/tbk-live-cart-tracker\.js/i.test(item.src));
    if (script) return script.src.replace(/tbk-live-cart-tracker\.js.*$/i, '');
    return 'https://tbkmotorsports.com/cdn/shop/t/4/assets/';
  };

  const installStyle = () => {
    if (document.getElementById('tbk-brand-logo-grid-safety-style')) return;
    const style = document.createElement('style');
    style.id = 'tbk-brand-logo-grid-safety-style';
    style.textContent = [
      '.tbk-brands__grid{grid-template-columns:repeat(6,minmax(0,1fr))!important;border:1px solid rgba(16,16,16,.16)!important;background:rgba(16,16,16,.16)!important;gap:1px!important;}',
      '.tbk-brand-card{min-height:96px!important;display:flex!important;align-items:center!important;justify-content:center!important;min-width:0!important;padding:18px 16px!important;background:#fff!important;color:#101010!important;text-decoration:none!important;text-align:center!important;transition:background .18s ease,transform .18s ease,box-shadow .18s ease!important;}',
      '.tbk-brand-card:hover{background:#f1efe8!important;transform:translateY(-2px)!important;box-shadow:0 14px 26px rgba(16,16,16,.08)!important;z-index:1!important;}',
      '.tbk-brand-card--dark{background:#101010!important;}',
      '.tbk-brand-card--dark:hover{background:#171717!important;}',
      '.tbk-brand-card img{display:block!important;width:auto!important;height:auto!important;max-width:min(88%,184px)!important;max-height:66px!important;object-fit:contain!important;}',
      '.tbk-brand-card--rampage-light img{max-width:min(92%,202px)!important;max-height:70px!important;}',
      '.tbk-brand-card--csf img{max-width:min(82%,168px)!important;max-height:62px!important;}',
      '.tbk-brand-card span{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;clip-path:inset(50%)!important;white-space:nowrap!important;}',
      '@media screen and (max-width:1199px){.tbk-brands__grid{grid-template-columns:repeat(3,minmax(0,1fr))!important;}}',
      '@media screen and (max-width:749px){.tbk-brands__grid{grid-template-columns:repeat(2,minmax(0,1fr))!important;}.tbk-brand-card{min-height:82px!important;padding:14px 12px!important;}.tbk-brand-card img{max-width:88%!important;max-height:54px!important;}.tbk-brand-card--rampage-light img{max-width:94%!important;max-height:58px!important;}.tbk-brand-card--csf img{max-width:84%!important;max-height:54px!important;}}'
    ].join('');
    document.head.appendChild(style);
  };

  const upgradeBrandGrid = () => {
    const grid = document.querySelector('.tbk-brands__grid');
    if (!grid) return;
    const visibleLogoCount = grid.querySelectorAll('img[src*="tbk-brand-logo-"]').length;
    const hasDeferredLogo = grid.querySelector('img[data-tbk-asset], template.tbk-deferred-media-template, .tbk-brand-logo-placeholder');
    installStyle();
    if (visibleLogoCount >= brands.length && !hasDeferredLogo) return;
    const base = getAssetBase();
    grid.innerHTML = brands.map(([title, href, file, dark]) => {
      const slug = file.replace(/^tbk-brand-logo-/, '').replace(/\.[a-z0-9]+$/i, '');
      const cls = (dark ? 'tbk-brand-card tbk-brand-card--dark ' : 'tbk-brand-card ') + 'tbk-brand-card--' + slug;
      const src = /.(png|jpe?g)$/i.test(file) ? base + file + '?width=360' : base + file;
      return '<a class="' + cls + '" href="' + href + '" aria-label="Shop ' + escapeHtml(title) + ' parts">' +
        '<img src="' + src + '" alt="' + escapeHtml(title) + ' logo" loading="lazy" width="180" height="72">' +
        '<span>' + escapeHtml(title) + '</span>' +
      '</a>';
    }).join('');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', upgradeBrandGrid, { once: true });
  } else {
    upgradeBrandGrid();
  }
  window.addEventListener('load', upgradeBrandGrid, { once: true });
  setTimeout(upgradeBrandGrid, 800);
})();
/* TBK brand logo grid safety end */
/* TBK builds nav fallback start */
(() => {
  const ids = ['builds', 'shopify-section-template--20958068080795__tbk-home-builds-v2-1781187507774'];
  const home = () => location.pathname === '/' || location.pathname === '';
  const target = () => ids.map(id => document.getElementById(id)).find(Boolean) || document.querySelector('.tbk-builds-v2');
  const scroll = (smooth) => {
    const el = target();
    if (!el) return false;
    const header = document.querySelector('.shopify-section-header-sticky, sticky-header, .header-wrapper, header');
    const offset = Math.max(92, Math.min(150, (header?.getBoundingClientRect().height || 104) + 22));
    window.scrollTo({ top: Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - offset), behavior: smooth ? 'smooth' : 'auto' });
    return true;
  };
  const isBuilds = (link) => {
    if (!link) return false;
    if (link.id === 'HeaderMenu-builds' || link.id === 'HeaderDrawer-builds') return true;
    const href = link.getAttribute('href') || '';
    return href === '#builds' || href === '/#builds' || href.includes('#shopify-section-template--20958068080795__tbk-home-builds-v2-1781187507774');
  };
  if (window.__tbkBuildsCartTrackerFallback) return;
  window.__tbkBuildsCartTrackerFallback = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a');
    if (!isBuilds(link) || !home() || !target()) return;
    event.preventDefault();
    history.replaceState(null, '', '#builds');
    scroll(true);
  }, true);
  if (location.hash === '#builds' || location.hash === '#shopify-section-template--20958068080795__tbk-home-builds-v2-1781187507774') {
    setTimeout(() => scroll(false), 150);
    setTimeout(() => scroll(false), 800);
  }
})();
/* TBK builds nav fallback end */

/* TBK sold-out and ACT storefront scrub start */
(function () {
  function removeBadProductCards(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.product-card-wrapper, li.grid__item').forEach(function (node) {
      var card = node.matches && node.matches('.product-card-wrapper') ? node : node.querySelector && node.querySelector('.product-card-wrapper');
      var holder = node.closest && node.closest('li.grid__item') ? node.closest('li.grid__item') : node;
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      var title = '';
      var titleLink = node.querySelector && node.querySelector('.card__heading a, a.full-unstyled-link');
      if (titleLink) title = (titleLink.textContent || '').replace(/\s+/g, ' ').trim();
      var soldOut = /\bsold\s*out\b/i.test(text);
      var actProduct = /^ACT\b/i.test(title) || /\bAction\s+Clutch\b/i.test(title) || /\bXClutch\b/i.test(title);
      if ((soldOut || actProduct) && holder && holder.style) {
        holder.style.display = 'none';
        holder.setAttribute('data-tbk-hidden-product-card', soldOut ? 'sold-out' : 'act');
      } else if ((soldOut || actProduct) && card && card.style) {
        card.style.display = 'none';
        card.setAttribute('data-tbk-hidden-product-card', soldOut ? 'sold-out' : 'act');
      }
    });
  }

  function start() {
    removeBadProductCards(document);
    var grid = document.getElementById('ProductGridContainer') || document.body;
    if (!grid || !window.MutationObserver) return;
    new MutationObserver(function () {
      removeBadProductCards(grid);
    }).observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/* TBK sold-out and ACT storefront scrub end */

/* TBK live-cart cache touch 2026-07-02T00:00:43.009Z */
